import React, { useContext } from "react";
import logo from '../img/RTN_Logo.png';
import { AppContext } from "./AppContext";

// Logo data here is pulled from Kirby
// If custom design is required, feel free to replace with whatever element is required

const rtnmap = (window as any).rtnmap || {};
export const Logo: React.FC = () => {
    const {setMobileToggle, mobileToggle} = useContext(AppContext);
    // return <a className="logo" href={rtnmap?.header?.url || '/'} dangerouslySetInnerHTML={{__html: rtnmap?.header?.html || 'Test site'}}></a>
    return <div className="logo p-5 flex flex-row">
        <div className="flex-1">
            <a className="logo" href={rtnmap?.header?.url || '/'}>
                <img src={logo} alt="Logo" className="w-96 md:max-w-full" />
            </a>
        </div>
        <div className="md:hidden">
            <button onClick={() => setMobileToggle(!mobileToggle)}>
            <i className="fal fa-times text-3xl pl-3 pb-3 absolute top-2 right-4"></i>
            </button>
        </div>
    </div>
}